export const VueOfflineMixin = {
    data() {
        return {
            isOnline: false,
            isOffline: false
        }
    },
    mounted() {
        navigator.onLine ? this.isOnline = true : this.isOffline = true

        window.addEventListener('online', this.onlineHandler)
        window.addEventListener('offline', this.offlineHandler)
    },
    beforeDestroy() {
        window.removeEventListener("online", this.onlineHandler);
        window.removeEventListener("offline", this.offlineHandler);
    },
    methods: {
        onlineHandler() {
            this.$emit('online')
            this.isOnline = true
            this.isOffline = false
        },
        offlineHandler() {
            this.$emit('offline')
            this.isOffline = true
            this.isOnline = false
        }
    }
}